
import { Options, Vue } from "vue-class-component";
import AppButton from "@/components/common/AppButton.vue";

import IXdrToken from "@/entities/IXdrToken";
import XdrToken from "@/entities/XdrToken";
import FeeBalanceInfo from "@/components/turret/fee-balance/FeeBalanceInfo.vue";
import XdrTokenForm from "@/components/turret/xdr-token/XdrTokenForm.vue";
import AppInput from "@/components/common/form/AppInput.vue";
import JsonTreeView from "@/components/common/JsonTreeView.vue";
import scrollToBottom from "@/helpers/domHelper";
import { getFeeBalance } from "@/services/turret/turret";

@Options({
  components: {
    FeeBalanceInfo,
    JsonTreeView,
    AppInput,
    XdrTokenForm,
    AppButton,
  },
})
export default class CreateXdrToken extends Vue {
  private xdrToken: IXdrToken = XdrToken.createNull();
  private xdrTokenRaw = "";
  private createXdrTokenError = null;
  private isLoading = false;

  async handleXdrTokenCreated(rawXdrToken: string): Promise<void> {
    this.isLoading = true;
    this.xdrToken = XdrToken.createNull();
    this.xdrTokenRaw = rawXdrToken;
    this.createXdrTokenError = null;
    const turret = this.$store.state.turret;

    try {
      const txFeeData = await getFeeBalance(turret, rawXdrToken);
      this.xdrToken = txFeeData as IXdrToken;
    } catch (e) {
      this.createXdrTokenError = e;
    }

    this.isLoading = false;

    await this.$nextTick(scrollToBottom);
  }
}
